import Request from "../lib/request";
import {
  CHANGE_PASSWORD_API,
  UPDATE_INFO_API,
  USER_API,
  USERS_API
} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const getInfo = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/${USER_API}`,
    needToken: true
  });
};

export const updateInfo = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USERS_API}/${UPDATE_INFO_API}`,
    needToken: true,
    data: data
  });
};

export const changePassword = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/${USERS_API}/${CHANGE_PASSWORD_API}`,
    needToken: true,
    data: data
  });
};
